import React, { useState, useEffect } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"
import axios from "axios"
import { toast } from "react-toastify"

import "./User.sass"
import { formatDate } from "../../../utils/format-date.js"

const USER_GROUPS = [{ id: "admin", name: "admin" }]

const SelectElement = ({ options, value, name, field, setUserData }) => {
  if (!options) return <div></div>

  return (
    <select
      name={name}
      className="editable-input"
      id={name}
      value={value ? "1" : "0"}
      onChange={(event) => {
        setUserData((prevUserData) => ({
          ...prevUserData,
          [field]: event.target.value === "1",
        }))
      }}
    >
      {options.map((option) => (
        <option key={option.id} value={option.id.toString()}>
          {option.name}
        </option>
      ))}
    </select>
  )
}

const getUserGroups = (user) => (user?.isAdmin === true ? ["admin"] : [])

const User = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const userId = location.pathname.split("/")[3]

  const [userData, setUserData] = useState({})
  const [initialUserData, setInitialUserData] = useState({})

  useEffect(() => {
    const isDirty = JSON.stringify(userData) !== JSON.stringify(initialUserData)

    const saveBtn = document.getElementById("saveBtn")
    if (saveBtn) {
      if (isDirty) {
        saveBtn.classList.add("savable")
      } else {
        saveBtn.classList.remove("savable")
      }
    }
  }, [userData, initialUserData])

  useEffect(() => {
    const token = localStorage.getItem("token")

    const api = axios.create({
      baseURL: process.env.REACT_APP_API_URL,
      headers: {
        Authorization: token,
      },
    })

    api
      .get("user/user/" + userId)
      .then((response) => {
        const user = {
          ...response.data,
          isActive: response.data.isActive !== false,
          isAdmin: response.data.isAdmin === true,
        }
        setUserData(user)
        setInitialUserData(user)
      })
      .catch((error) => {
        console.log("Error loading users:" + error.config)
      })
  }, [userId])

  const handleRoleChange = (event) => {
    const { name, checked } = event.target
    if (name !== "admin") return

    setUserData((prevUserData) => ({
      ...prevUserData,
      isAdmin: checked,
    }))
  }

  const onSubmitUser = async () => {
    const { name, isActive, isAdmin, id } = userData

    if (!name) {
      toast.error("Usuários devem ter um nome atribuído", { theme: "colored" })
      return
    }

    const token = localStorage.getItem("token")
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}user/update/${id}`,
        { name, isActive, isAdmin },
        { headers: { Authorization: token } }
      )

      if (response.status === 200) {
        const updatedUser = {
          ...response.data,
          isActive: response.data.isActive !== false,
          isAdmin: response.data.isAdmin === true,
        }
        setUserData(updatedUser)
        setInitialUserData(updatedUser)
        toast.success("Usuário atualizado com sucesso", { theme: "colored" })
        navigate("/admin")
      }
    } catch (error) {
      toast.error(
        error.response?.data?.error ||
          "Ocorreu um erro na atualização do usuário",
        {
          theme: "colored",
        }
      )
      console.error(error)
    }
  }

  const statuses = [
    { name: "Ativo", id: 1 },
    { name: "Inativo", id: 0 },
  ]

  return (
    <div id="content-wrapper">
      <div id="top-actions">
        <Link to="/admin">
          <div className="action">
            <img
              src="/assets/icons/chevron.svg"
              alt=""
              className="icon chevron-left"
            />
            <span className="font text-2">Voltar</span>
          </div>
        </Link>
      </div>
      <div id="content-header">
        <div className="info-item">
          <span className="text-4 font">
            <strong>{initialUserData.name}</strong>
          </span>
          <br />
          <span className="text-1 font">Usuário</span>
        </div>
        <div>
          <div className="info-item">
            <span className="text-4 font">
              <strong>{getUserGroups(initialUserData).join(", ")}</strong>
            </span>
            <br />
            <span className="text-1 font">Grupo(s)</span>
          </div>
          <div className="info-item">
            <span className="text-4 font">
              <strong>{formatDate(initialUserData.createdOn)}</strong>
            </span>
            <br />
            <span className="text-1 font">Data criação</span>
          </div>
          <div className="info-item">
            <span className="text-4 font">
              <strong>
                {initialUserData.isActive !== false ? "Ativo" : "Inativo"}
              </strong>
            </span>
            <br />
            <span className="text-1 font">Status</span>
          </div>
        </div>
      </div>
      <div id="inside-content-wrapper">
        <div className="contract-info">
          <div className="contract-info-header">
            <span className="font text-4">Detalhes do usuário</span>
            <div className="save-btn" id="saveBtn" onClick={onSubmitUser}>
              <span className="font text-2">Salvar</span>
              <img
                src="/assets/icons/save.svg"
                className="icon"
                alt="save icon"
              />
            </div>
          </div>
          <table className="contract-info-content">
            <tbody>
              <tr>
                <td>
                  <strong>ID</strong>
                </td>
                <td>{userData.id}</td>
              </tr>
              <tr className="editable">
                <td>
                  <strong>Nome</strong>
                  <img
                    src="/assets/icons/pencil.svg"
                    className="icon"
                    alt="edit icon"
                  />
                </td>
                <td>
                  <input
                    className="editable-input"
                    id="name"
                    type="text"
                    value={userData.name || ""}
                    onChange={(event) =>
                      setUserData({ ...userData, name: event.target.value })
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Email</strong>
                </td>
                <td>{userData.email}</td>
              </tr>
              <tr>
                <td>
                  <strong>Contrato</strong>
                </td>
                <td>
                  {userData.contract != undefined
                    ? `${userData.contract.name} (${userData.contract.id})`
                    : "Não possui"}
                </td>
              </tr>
              <tr className="editable">
                <td>
                  <strong>Grupo(s)</strong>
                  <img
                    src="/assets/icons/pencil.svg"
                    className="icon"
                    alt="edit icon"
                  />
                </td>
                <td>
                  {USER_GROUPS.map((role) => (
                    <div className="role-checkbox-item" key={role.id}>
                      <input
                        type="checkbox"
                        name={role.name}
                        checked={getUserGroups(userData).includes(role.name)}
                        onChange={handleRoleChange}
                      />
                      {role.name}
                    </div>
                  ))}
                </td>
              </tr>
              <tr className="editable">
                <td>
                  <strong>Status</strong>
                  <img
                    src="/assets/icons/pencil.svg"
                    className="icon"
                    alt="edit icon"
                  />
                </td>
                <td>
                  <SelectElement
                    options={statuses}
                    value={userData.isActive !== false}
                    name="user-status"
                    field="isActive"
                    setUserData={setUserData}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Data criação</strong>
                </td>
                <td>{formatDate(userData.createdOn)}</td>
              </tr>
              <tr>
                <td>
                  <strong>Data atualização</strong>
                </td>
                <td>{formatDate(userData.updatedOn)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default User
